const initialState = {
  loading: false,
  loaded: false,
  errors: {},
  filters: [],
};

const assignedFilters = (state = initialState, {
  type,
  payload,
}) => {
  switch (type) {
    case 'ASSIGNED_FILTERS_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'ASSIGNED_FILTERS_LIST_SUCCESS':
      return {
        ...state,
        loaded: true,
        loading: false,
        filters: payload,
      };
    case 'ASSIGNED_FILTER_COUNT_SUCCESS': {
      const newState = {
        ...state,
        loaded: true,
        loading: false,
      };
      if (payload && (payload.id || null)) {
        newState[`filter${payload.id}PhaseCounts`] = payload;
      }
      return newState;
    } case 'ASSIGNED_FILTERS_LIST_FAILURE':
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: payload.errors,
      };
    case 'ASSIGNED_FILTER_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

export default assignedFilters;



// WEBPACK FOOTER //
// ./client/app/reducers/assigned_filters.js